module.exports = __webpack_public_path__ + "static/img/recruiter-awards_Official-logos-2020-winner.dc69e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticker/recruiter-awards_Official-logos-2020-winner.png
// module id = CXZ7
// module chunks = 0